<template>
    <div>
        <h2>Instagram Service</h2>
        <span> Your instagram integration is completed. You can now use the service. </span>
        <div class="mt-5"></div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "IGStatusViewer",
    data() {
        return {
            imageRefreshKey: 0,
            imageData: null,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            initialized: (state) => state.instagram.info.initialized,
            status: (state) => state.instagram.info.status,
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {},
    mounted() {},
    beforeDestroy() {},
};
</script>

<style scoped></style>
